import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import swal from "sweetalert";
import Button from "@mui/material/Button";

const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function PhoneNumber({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
     const [phoneNumberOfHome, setPhoneNumberOfHome]=useState(object?.phone_number_home);
     const [phoneNumberOfWork, setPhoneNumberOfWork]=useState(object?.phone_number_work);

     const [loading,setLoading]=useState(false)
     const updateData=async()=>{
         let data=null;
         setLoading(true);
         try{
             data=await axios({
                method: 'put',
                url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
                data:{
                 section_name:'5',
                 phone_number_work:phoneNumberOfWork,
                 phone_number_home:phoneNumberOfHome,
                 user_id:cookies.get('user_id'),
                 role_id:cookies.get('role_id')+1,
                 section_id:section_id,
                 stage_transaction_type_id:stage_transaction_type_id
                },
                headers:{
                 'Content-Type': 'application/json',
                 'Accept': 'application/json',
                 "X-localization": language,
                }
             })
             if(data){
                 if(data?.data?.status==200){
                     swal("تم التحديث!", `${data?.data?.message}`, "success");
                     setPhoneNumberOfHome(data?.data?.data?.phone_number_home);
                     setPhoneNumberOfWork(data?.data?.data?.phone_number_work);
                     advanceSearch()
                     getCurrentReportDataAfterUpdate()

                 }else if(data?.data?.status==503){
                     let messages='';
                     data?.data?.data?.phone_number_home?.map((ms)=>{
                        messages+=ms+"\n";
                     })
                     data?.data?.data?.phone_number_work?.map((ms)=>{
                        messages+=ms+"\n";
                     })
                     swal("فشل التحديث!", `${messages}`, "warning");

                 }else{
                     console.log(data?.data?.message);
                     swal("فشل التحديث!", `${data?.data?.message}`, "warning");
 
                 }
             }
         setLoading(false);
 
         }catch(err){
             swal("فشل التحديث!", `${err?.message}`, "error");
             setLoading(false);
 
         }
         
     }
     const checkAccessPrivileges =()=>{
        let check=true;
        Access?.map((data)=>{
            if(data==1){
                check=true;
            }else if(data==2||data==3||data==4){
                check=false
            }
        })
        return check;
    }
    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }

    return (
        <>
            {/*###==> phone number info here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                ارقام الهاتف
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width: "50%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="السكن"
                            variant="outlined"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={phoneNumberOfHome}
                            onChange={(e) => {
                                setPhoneNumberOfHome(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.phoneNumberHome) {
                            return err.phoneNumberHome;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "50%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="العمل"
                            variant="outlined"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={phoneNumberOfWork}
                            onChange={(e) => {
                                setPhoneNumberOfWork(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.phoneNumberWork) {
                            return err.phoneNumberWork;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>
            </div>
            {
                checkAccessPrivilegesCanAdd()||checkAccessPrivilegesCanEdit()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        "تحديث"
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>
                :null
            }
        </>
    )
}

export default PhoneNumber